import Header from '../components/Header'
import Footer from '../components/Footer'

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0a0e17]">
      <Header />

      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="card">
          <h1 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: "'Orbitron', sans-serif" }}>
            Privacy Policy
          </h1>
          <p className="text-gray-400 text-sm mb-8">Last updated: February 5, 2026</p>

          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold text-white mb-3">1. Information We Collect</h2>
              <p>
                We collect information you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Account information (name, email, password)</li>
                <li>Content you submit for scam analysis (emails, messages, phone numbers)</li>
                <li>Usage data and analytics</li>
                <li>Device and browser information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">2. How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and improve our fraud detection services</li>
                <li>Analyze patterns and improve detection algorithms</li>
                <li>Send service-related communications</li>
                <li>Protect against fraud and abuse</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">3. Data Security</h2>
              <p>
                We implement industry-standard security measures to protect your data:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>End-to-end encryption for sensitive data</li>
                <li>Secure database storage with access controls</li>
                <li>Regular security audits and monitoring</li>
                <li>GDPR and CCPA compliant data handling</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">4. Data Sharing</h2>
              <p>
                We do not sell your personal information. We may share data with:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Service Providers:</strong> Third-party services that help us operate (e.g., cloud hosting, AI processing)</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect rights and safety</li>
                <li><strong>Aggregated Data:</strong> Anonymous, aggregated statistics for research and improvement</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Export your data</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">6. Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies for:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Session management and authentication</li>
                <li>Analytics and performance monitoring</li>
                <li>Personalizing your experience</li>
              </ul>
              <p className="mt-2">
                You can control cookies through your browser settings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">7. Data Retention</h2>
              <p>
                We retain your data for as long as necessary to provide services and comply with legal obligations.
                Scan data is typically retained for 90 days unless required for fraud prevention.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">8. Children's Privacy</h2>
              <p>
                ScamView is not intended for users under 18 years of age. We do not knowingly collect
                information from children.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">9. International Users</h2>
              <p>
                Your information may be transferred to and processed in countries where our servers are located.
                We ensure appropriate safeguards are in place for international data transfers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-3">10. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of significant changes
                via email or prominent notice on our website.
              </p>
            </section>

            <section className="pt-6 border-t border-white/10">
              <h2 className="text-2xl font-bold text-white mb-3">Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us:
              </p>
              <ul className="mt-2 space-y-1">
                <li>Email: privacy@scamview.com</li>
                <li>Address: 123 Tech Street, San Francisco, CA 94105</li>
              </ul>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
